'use client';

import StatusPage from '@/components/Common/StatusPage';
import { useEffect } from 'react';

/**
 * Fallback for routes outside (home). Root layout still wraps this.
 */
export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Root error boundary:', error);
  }, [error]);

  return (
    <StatusPage
      variant="error"
      onRetry={reset}
      detail={
        process.env.NODE_ENV === 'development'
          ? error.message
          : error.digest
            ? `Codice: ${error.digest}`
            : null
      }
    />
  );
}
